module.exports = {
  "country": "MK",
  "artist": "Kaliopi",
  "song": "Crno i belo",
  "year": "2012",
  "place": "13",
  "spotify": "0DJ6U66PPWnbuXF84pvG1T"
};